"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listServiceFactory = void 0;
// listService factory
exports.listServiceFactory = ['app.config', '$http', '$q', '$rootScope', listService];
function listService(config, $http, $q, $rootScope) {
    var service = {
        getAll: getAll,
        get: get,
    };
    return service;
    ////
    function getAll(retries) {
        return get('All', retries);
    }
    function get(listName, retries) {
        if (listName == undefined) {
            listName = 'All';
        }
        if (retries == undefined) {
            retries = 5;
        }
        return $http
            .post(config.api, {
            action: 'lists',
            listName: listName,
        })
            .then(function (response) {
            return response;
        }, function (error) {
            if (error.status == 500 && retries-- > 0) {
                console.log('listService.getAll() - retry - %s', retries);
                return getAll(retries);
            }
            else if (error.status === 401) {
                console.log('Lists request failed with 401, waiting for auth refresh...');
                return $q(function (resolve, reject) {
                    var authRefreshHandler = $rootScope.$on('auth:tokenRefreshed', function () {
                        console.log('Auth refreshed, retrying lists request...');
                        authRefreshHandler(); // Unregister the handler
                        // Retry the request
                        get(listName, retries).then(resolve, reject);
                    });
                });
            }
            else {
                console.log('listService.getAll() - failed');
                return $q.reject(error);
            }
        });
    }
}
